import { useState } from "react";
import { DialogContent } from "@mui/material";
import styled from "styled-components";
import JSONInput from "react-json-editor-ajrm";
import { locale } from "../../../rule-engine-core/Common/JsonInputLocale";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { UIStandardLayer } from "../../BuildlingBlocks/UIStandardLayer";
import { ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

interface IEditModal {
    open: boolean;
    onClose: () => void;
    onEdit: (value: object) => void;
    value: string;
    error?: string;
    title?: string;
}

export const EditModal: React.FC<IEditModal> = (props: IEditModal) => {
    const error = props.error;
    const [value, setValue] = useState<object>(JSON.parse(props.value));

    const onChange = (newConf: object) => {
        // only update for valid jsObject
        let jsObject = Reflect.get(newConf, "jsObject");
        if (jsObject) setValue(jsObject);
    };

    return (
        <UIStandardLayer
            open={props.open}
            onClose={props.onClose}
            title={props.title ? props.title : `Edit JSON`}
            validationIssues={error ? [new ValidationIssue(error)] : undefined}
            primaryActionText={"Update"}
            onPrimaryAction={() => props.onEdit(value)}
            secondaryActionText={"Close"}
            onSecondaryAction={props.onClose}
            renderUI={() => {
                return (
                    <DialogContent>
                        <EditJsonDiv>
                            <JSONInput
                                placeholder={value}
                                locale={locale}
                                theme={"light_mitsuketa_tribute"}
                                style={{
                                    outerBox: {
                                        width: "100%",
                                    },
                                    container: {
                                        width: "100%",
                                    },
                                }}
                                onChange={onChange}
                            />
                        </EditJsonDiv>
                    </DialogContent>
                );
            }}
        ></UIStandardLayer>
    );
};

const EditJsonDiv = styled.div`
    min-width: 800px;

    .MuiInputBase-multiline {
        background: ${UIStyleConstants.BLACK_COLOR};
        font-family: MyFancyCustomFont, monospace;
        font-size: inherit;
        color: ${UIStyleConstants.YELLOW_DARK_COLOR};
    }
`;
